var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.4375 1.4375H2.4375V3.4375V51.5625V53.5625H4.4375H52.5625H54.5625V51.5625V3.4375V1.4375H52.5625H4.4375Z",
    fill: "#F5DE19",
    stroke: "#001E36",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7655 41.0352C37.1755 41.8681 37.8126 42.5681 38.6032 43.0547C39.3939 43.5412 40.3059 43.7945 41.2343 43.7852C43.1077 43.7852 44.3057 42.8484 44.3057 41.5508C44.3057 40.0039 43.075 39.4505 41.0125 38.5481L39.8816 38.0634C36.616 36.673 34.4503 34.9319 34.4503 31.2503C34.4503 27.8592 37.0285 25.2759 41.0727 25.2759C42.3819 25.1814 43.6899 25.4744 44.8337 26.1184C45.9774 26.7624 46.9062 27.7289 47.5043 28.8973L43.9688 31.1575C43.7385 30.5781 43.3376 30.0825 42.8191 29.7362C42.3006 29.39 41.6892 29.2095 41.0658 29.2188C40.7938 29.1915 40.5192 29.2213 40.2593 29.306C39.9995 29.3908 39.7601 29.5288 39.5566 29.7112C39.353 29.8936 39.1896 30.1164 39.0769 30.3654C38.9642 30.6144 38.9046 30.8842 38.9019 31.1575C38.9019 32.5136 39.7424 33.0636 41.6828 33.9075L42.8138 34.3922C46.6569 36.0405 48.8294 37.7197 48.8294 41.4958C48.8294 45.5675 45.6308 47.7984 41.3357 47.7984C39.6621 47.9051 37.9935 47.5251 36.5311 46.7044C35.0687 45.8837 33.8751 44.6573 33.0943 43.1733L36.7655 41.0352ZM20.7897 41.427C21.4996 42.6869 22.1458 43.7525 23.6996 43.7525C25.1846 43.7525 26.123 43.1716 26.123 40.9114V25.5338H30.645V40.9716C30.645 45.6534 27.895 47.7847 23.8921 47.7847C22.4771 47.862 21.0719 47.5094 19.8611 46.7732C18.6502 46.0369 17.6906 44.9515 17.1082 43.6597L20.7897 41.427Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJs);
export default __webpack_public_path__ + "static/media/js.af60ec4bb6c786fd41f68710a11578eb.svg";
export { ForwardRef as ReactComponent };